import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const RequirementsForHashFunctionsModule = () => (
  <QPhototModuleSubtopic
    title="Requirements for Hash Functions, Security of Hash Functions"
    videos={[
      "https://www.youtube.com/embed/tty5lwlZvYA",
      "https://www.youtube.com/embed/jNoUtbK8hv4"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);

export default RequirementsForHashFunctionsModule;
